const AlertIcon = ({ size = '32', fill = '#036EBC' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.793 2C7.27297 2 2.79297 6.48 2.79297 12C2.79297 17.52 7.27297 22 12.793 22C18.313 22 22.793 17.52 22.793 12C22.793 6.48 18.313 2 12.793 2ZM13.793 17H11.793V15H13.793V17ZM13.793 13H11.793V7H13.793V13Z"
        fill={fill}
      />
    </svg>
  );
};

export default AlertIcon;
